import {
  MUTATION_RESPONSE_RECEIVED,
  MUTATION_REQUIRED,
} from '@web-platform/shared-universal-constants/src/network';
import { RADAR_CREATE_SESSIONS } from '@web-platform/shared-universal-types/src/network/requestTypes';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { MutationStatusState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/radar';

export const INITIAL_STATE: MutationStatusState = { loading: false };

export default (
  state: MutationStatusState = INITIAL_STATE,
  action: Action,
): MutationStatusState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED: {
      if (action.payload.type === RADAR_CREATE_SESSIONS) {
        return { ...state, loading: false };
      }
      return state;
    }

    case MUTATION_REQUIRED: {
      if (action.payload.type === RADAR_CREATE_SESSIONS) {
        return { ...state, loading: true };
      }
      return state;
    }

    default:
      return state;
  }
};

export const isLoading = (state: MutationStatusState): boolean => state.loading;
